// extracted by mini-css-extract-plugin
export default {"cell":"GridDefaultCellTemplate_cell__VKCSC"};